import { createApp } from 'vue'
import AppRoot from './AppRoot.vue'
import store from './store'
import router from './router'
import './assets/tailwind.css'

// Since we're using Mapbox only, no need to load Google Maps
createApp(AppRoot).use(store).use(router).mount('#app')

